import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ConfigProvider} from "antd";
import frFR from 'antd/locale/fr_FR';

import 'dayjs/locale/fr'
import dayjs from "dayjs";
import {PermifyProvider} from "@permify/react-role";

dayjs.locale('fr')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ConfigProvider
          theme={{
              token: {
                  fontFamily: "Montserrat",
                  colorPrimary: "#004ba1",
                  colorTextBase: "#1E293BFF",
                  fontSize: 14,
              },
          }}
          locale={frFR}
      >
          <PermifyProvider>
              <App />
          </PermifyProvider>
      </ConfigProvider>
  </React.StrictMode>
);